import {Amplify} from "aws-amplify";

export let authConfigurationError: string | null = null;

export async function initializeAuth(): Promise<void> {
  try {
    let userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
    let userPoolClientId = process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID;
    if (!userPoolId || !userPoolClientId) {
      const response = await fetch(`${process.env.PUBLIC_URL || ""}/auth-config.json`, {cache: "no-store"});
      if (!response.ok) throw new Error("Missing authentication configuration");
      const config = await response.json();
      userPoolId = config.userPoolId;
      userPoolClientId = config.userPoolClientId;
    }
    if (!userPoolId || !userPoolClientId) throw new Error("Missing Cognito IDs");
    Amplify.configure({Auth: {Cognito: {userPoolId, userPoolClientId, loginWith: {email: true}}}});
    authConfigurationError = null;
  } catch {
    authConfigurationError = "Sign-in is not configured yet. Please deploy the authentication configuration or set the local Cognito environment variables.";
  }
}
